import { ComponentProps, FC } from 'react';
import dayjs from 'dayjs';
import { DatePicker } from 'antd';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { CalendarTodayOutlined } from '@mui/icons-material';
import { Stack, useTheme } from '@mui/material';
import { getNightOrDayPalette } from '../utils/getNightOrDayPalette';

const { RangePicker } = DatePicker;

type Props = Omit<ComponentProps<typeof RangePicker>, 'value' | 'onChange'> &
	Readonly<{
		value: [string | null, string | null] | null;
		onChange: (value: [string | null, string | null]) => void;
	}>;

const DateRangePicker: FC<Props> = ({ value, onChange, ...props }) => {
	const theme = useTheme();

	return (
		<Stack
			direction={'row'}
			flexWrap={'nowrap'}
			width={'100%'}
			alignItems={'center'}
			sx={{
				border: (theme) => `1px solid ${theme.palette[getNightOrDayPalette(theme)][300]}`,
				px: 1.5,
				borderRadius: 1,
				paddingRight: 0,
			}}
		>
			<CalendarTodayOutlined color={'secondary'} />
			<RangePicker
				size={'large'}
				bordered={false}
				style={{ width: '100%' }}
				popupStyle={{ zIndex: theme.zIndex.datePicker }}
				suffixIcon={<ArrowDropDownIcon sx={{ position: 'relative', right: '-5px', color: (theme) => theme.palette.grey[800] }} />}
				value={[value?.[0] == null ? null : dayjs(value[0]), value?.[1] == null ? null : dayjs(value[1]).subtract(1, 'day')]}
				onChange={(value) => {
					onChange([
						value?.[0] == null ? null : `${value[0].format('YYYY-MM-DD')}T00:00:00Z` /* date picker should not have time portion set */,
						value?.[1] == null
							? null
							: `${value[1].add(1, 'day').format('YYYY-MM-DD')}T00:00:00Z` /* date picker should not have time portion set */,
					]);
				}}
				{...props}
			/>
		</Stack>
	);
};

export { DateRangePicker };
